import ArticleTemplate from "../components/ArticleTemplate";
import { articles } from "@/mocks/articles";

export default function ArticleVsOrientdig() {
  return <ArticleTemplate article={articles[6]} />;
}